import type { GridStateColumn } from './GridStateColumn';

export class CustomGridState {
    /**
     * The unique id of the grid
     */
    public gridkey: string;

    /**
     * The order of the columns
     */
    public columnOrder: string[] | undefined = undefined;

    /**
     * The widths of the columns
     */
    public columnWidths: GridStateColumn[] | undefined = undefined;

    /**
     * The hidden columns
     */
    public hiddenColumns: string[] | undefined = undefined;

    public constructor(gridkey: string) {
        this.gridkey = gridkey;
    }
}
